import { render, staticRenderFns } from "./landnumadd.vue?vue&type=template&id=191428be&scoped=true&"
import script from "./landnumadd.vue?vue&type=script&lang=js&"
export * from "./landnumadd.vue?vue&type=script&lang=js&"
import style0 from "./landnumadd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./landnumadd.vue?vue&type=style&index=1&id=191428be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191428be",
  null
  
)

export default component.exports